import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LoginInfo } from 'mbs-ui-shared@models/login';
import { getObjectWithoutEmptyProp } from 'mbs-ui-shared@utils/object-to-params';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private http = inject(HttpClient);

  public getInfo(alias: string) {
    return this.http.get<LoginInfo>('api/login/info', {
      params: new HttpParams({ fromObject: getObjectWithoutEmptyProp({ alias }) })
    });
  }

  public getUserInfo(alias: string, providerId: string) {
    return this.http.get<LoginInfo>('api/login/user/info', {
      params: new HttpParams({ fromObject: getObjectWithoutEmptyProp({ alias, providerId }) })
    });
  }

  public sendRestorePasswordEmail(email: string) {
    return this.http.post('api/login/forgot-password', { email });
  }
}
